import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";

interface SummaryStepProps {
    onBack: (e: any) => void;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack }) => {
    const { values, submitForm } = useFormikContext<any>();
    const { translate } = useLocale();
    
    return <div className="pt-3 pr-3 flex flex-col h-full relative">
        <div className={`text-portal-blue-primary-shade2 text-xl font-semibold`} >
            {translate.byKey(TranslationKeys.summary)}
        </div>
        <div className="flex-1 overflow-y-auto pr-1 mb-16">
            <div className="flex flex-col flex-1">
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.name)}: <span className="text-sm text-black">{values.name}</span></h4>
                {
                    values.description ?
                        <h4 className="p-1 text-xs text-gray-600">
                            {translate.byKey(TranslationKeys.description)}{`:`} <span className="text-sm text-black">{values.description}</span>
                        </h4> : null
                }
            </div>

            {/* Only show Access Groups section if there are selected access groups */}
            {values.accessGroupRows && values.accessGroupRows.length > 0 && (
                <div className="flex flex-row flex-1">
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.accessGroups)}:</h4>
                    <ul className="flex flex-col">
                        {values.accessGroupRows.map((accessGroup: any, index: number) => {
                            return <li key={index}>
                                <span className="text-sm text-black">{accessGroup.name}</span>
                            </li>
                        })}
                    </ul>
                </div>)}

            {/* Only show Floor Groups section if there are selected floor groups */}
            {values.floorGroupRows && values.floorGroupRows.length > 0 && (
                <div className="flex flex-row flex-1">
                    <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.floorGroups)}:</h4>
                    <ul className="flex flex-col">
                        {values.floorGroupRows.map((floorGroup: any, index: number) => {
                            return <li key={index}>
                                <span className="text-sm text-black">{floorGroup.name}</span>
                            </li>
                        })}
                    </ul>
                </div>)}
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={onBack}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    id="submitAssignButtonId"
                    className={`py-1 px-5 secondary secondary-enabled`}
                    onClick={submitForm}>
                    {translate.byKey(TranslationKeys.submit)}
                </button>
            </div>
        </div>
    </div>
}

export default SummaryStep;
